import api, { EnterpriseRcb } from "api";
import { AppAction, AppButton, AppForm, AppFormItemEnum, AppFormLayout, AppFormPageProps, AppRow } from 'qcc';
import React from 'react';
const entAudStatus = {
  '0': '未认证',
  '1': '管理员资料已提交',
  '2': '企业基本资料(没有申请表)已提交',
  '3': '已提交待审核',
  '4': '审核通过',
  '5': '审核不通过',
  '6': '人工初审通过'
}
export default class EnterpriseRcbCertificateForm extends React.PureComponent<AppFormPageProps> {
  refAppForm = React.createRef<AppForm>()
  state = {
    mode: 2,
    key: 1,
    data: (this.props.formData || {}) as EnterpriseRcb
  }

  // 获取认证地址
  certificate = async () => {
    let { data, key } = this.state;
   
    // 调用法大大的接口
    AppAction.coverFull();
    let res = await api.public.fdd.verGetCompanyUrl(data);
    console.log("先调用法大大注册接口返回数据:", res);
    if (!res.result) {
      AppAction.cancelCoverFull();
      AppAction.errorMsg(res.msg);
    }

    let { transactionNo, url } = res.data as any;

    // 将数据保存
    data.personUrl = url;
    data.transactionNo = transactionNo;
    console.log("先调用法大大注册接口后数据:", data);
    let res1 = await api.posenterprisercb.certificate(data);

    AppAction.cancelCoverFull();

    AppAction.successMsg("操作成功");
    this.props.afterSave && this.props.afterSave();
    this.setState({ data: res1.data, key: key + 1 })
  }


  // 获取认证结果
  getStatus = async () => {
    let { data, key } = this.state;
    // 调用法大大的接口
    AppAction.coverFull();
    console.log("调用前数据:", data);
    let res = await api.public.fdd.findVerifyInfo(data);
    console.log("先调用法大大接口返回数据:",res);
    if(!res.result){
      AppAction.cancelCoverFull();
      AppAction.errorMsg(res.msg);
    }
    // 两次翻转转JSON转成对象
    let resultFdd: any = JSON.parse(JSON.stringify(res.data));
    console.log("JSON转成对象:", res);
    let status = resultFdd.company.status;
    data.status = status;
    console.log("先调用法大大接口后数据:", data);

    let res1 = await api.posenterprisercb.handleStatus(data);
    AppAction.cancelCoverFull();
    AppAction.successMsg("更新成功");
    this.props.afterSave && this.props.afterSave();
    this.setState({ data: res1.data, key: key + 1 })
  }

  openUrl = () => {
    let { data } = this.state;
    window.open(data.personUrl);
  }

  render() {
    let { formData, mode, id } = this.props;
    return (<AppFormLayout mode={this.props.mode} key={this.state.key} >
      <AppFormLayout.Form>
        <AppForm ref={this.refAppForm} entity='pos_enterprise_rcb' loadingData={false} mode={2} keyValue={id} formData={formData}
          afterSave={() => { this.props.afterSave && this.props.afterSave() }}>
          <AppForm.Section labelWidth={120} >
            <AppForm.Item label='企业名称'
              field='openName'
              itemType={AppFormItemEnum.input} readonly />
            <AppForm.Item label='企业标识'
              field='openId'
              itemType={AppFormItemEnum.input} readonly />
            <AppForm.Item label='认证状态'
              field='status'
              render={() => {
                return entAudStatus[this.state.data.status]
              }} />
            <AppForm.Item label='认证地址'
              field='personUrl'
              render={() => {
                return <a onClick={() => this.openUrl()}>{this.state.data.personUrl}</a>
              }} />

          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
      <AppFormLayout.Footer>
        <AppRow>
          {this.state.data.isCertificate === 1 ? <AppButton label="获取认证状态" type='primary' action={this.getStatus} /> : <AppButton label="获取认证地址" type='primary' action={this.certificate} />}
          <AppButton label="关闭" action={() => { AppAction.closeDialog() }} />
        </AppRow>
      </AppFormLayout.Footer>
    </AppFormLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/pos/enterpriseRcb/EnterpriseRcbCertificateForm.tsx